import React, { useEffect, useRef } from 'react';
import './Article.scss';
import { gsap } from './gsap';
import { createPopper } from '@popperjs/core';
import Hero from './Components/Hero/Hero';
import Hero2 from './Components/Hero/Hero2';
import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import InlinePhoto from './Components/Photos/InlinePhoto';
import FullWidthPhoto from './Components/Photos/FullWidthPhoto';
import Chapter1 from './Components/Chapters/Chapter1';
import Chapter2 from './Components/Chapters/Chapter2';
import Chapter3 from './Components/Chapters/Chapter3';
import Chapter4 from './Components/Chapters/Chapter4';
import Chapter5 from './Components/Chapters/Chapter5';
import Chapter6 from './Components/Chapters/Chapter6';
import Chapter7 from './Components/Chapters/Chapter7';
import PullQuoteWImg from './Components/PullQuote/PullQuoteWImg';
import Infographic from './Components/Infographic/Infographic';
import contents from './contents';
import RelatedContents from './Components/RelatedContents/RelatedContents';
import Reference from './Components/Reference/Reference';

//for fullWidth Photos
import fullbleedPhoto1 from './Assets/fullbleedPhoto1.jpg';
import fullbleedPhoto2 from './Assets/fullbleedPhoto2.jpg';

function Article({ heroBackgroundType, inlinePhotoSize, logoPlacement }) {
  //below states are for the audio player placement. See README for detail.

  //create refs for photos here if you want to add scale animation on scroll
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3, inline4]; // put all photo refs in this array

  const screenSizeRef = useRef(); //

  const photoSize = inlinePhotoSize !== undefined ? inlinePhotoSize : contents.inlinePhotos.size;

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);

  return (
    <div className="article">
      <div className="height" ref={screenSizeRef} />
      <Header clientName={contents.header} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        heroBackgroundType={heroBackgroundType}
        logoPlacement={logoPlacement}
      />
      <Hero2 />
      <Chapter1 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[0]} //pass in corresponding data
        photoRef={inline1} //pass in ref
      />
      <Chapter2 />
      <FullWidthPhoto
        photo={fullbleedPhoto1}
        alt={'someone in greenhouse'}
        caption={
          'A farmhand examines crop yields for Qukes® baby cucumbers at Perfection Two Wells'
        }
      />
      <PullQuoteWImg
        quote={
          '“We start collecting data before the seed is even planted [...] and our success depends on understanding the data, bringing it together, and building the appropriate infrastructure to act on it.”'
        }
      />
      <Chapter3 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[1]} //pass in corresponding data
        photoRef={inline2} //pass in ref
      />
      <Chapter4 />
      <Infographic />
      <Chapter5 />
      <FullWidthPhoto
        photo={fullbleedPhoto2}
        alt={'someone in greenhouse'}
        caption={'Freshly harvested Perfection Fresh Kumatoes®'}
      />
      <Chapter6 />
      <InlinePhoto
        photoSize={photoSize} //this is for Storybook. can be deleted
        photoContents={contents.inlinePhotos.contents[2]} //pass in corresponding data
        photoRef={inline3} //pass in ref
      />
      <Chapter7 />
      {/* <CtaButton
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
      /> */}
      <div className="article__divider" />
      <Reference />
      <RelatedContents />
      <Footer />
    </div>
  );
}

export default Article;
